<template>
  <link rel="preconnect" href="https://fonts.googleapis.com" />
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
  <link href="https://fonts.googleapis.com/css2?family=Syncopate:wght@400&display=swap" rel="stylesheet" />
  <!-- <img alt="Vue logo" src="./assets/logo.png"> -->
  <HelloWorld msg="New Website Coming Soon" />
</template>

<script>
import "modern-normalize/modern-normalize.css";
import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "App",
  components: {
    HelloWorld,
  },
  mounted() {},
};
</script>

<script setup>
import { onMounted } from "vue";

const fetchAndInsert = (url) =>
  window
    .fetch(url)
    .then((res) => res.text())
    .then((text) => document.body.insertAdjacentHTML("beforeend", text));

onMounted(() => {
  /*
  if (typeof window !== "undefined")
    fetchAndInsert(
      "/symbols-1.0.0.svg" // https://d3vhysnltdkzu.cloudfront.net/ortho.gg/symbols-1.0.0.svg
    );
  */
});
</script>

<style>
html {
  font-size: 16px;
  font-size: 1.2vmax;
  scroll-behavior: smooth;
  --fx-duration: 1s;
}
@media screen and (max-width: 768px) {
  html {
    /* font-size: 22px; */
    /* font-size: 1.25vmax; */
  }
}

#app {
  font-family: "Syncopate", sans-serif;
  font-weight: 400;
  font-style: normal;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
}
.context {
  min-height: 100vh;
  min-height: 100lvh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.content {
  flex-grow: 1;
  align-self: stretch;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem;
}
.h1 {
  font-size: 1.25rem;
}

.x-underline {
  text-decoration: none;
}
.x-underline:hover,
.x-underline:focus {
  text-decoration: underline;
}

.x-underline-fx {
  position: relative;
  text-decoration: none;
}
.x-underline-fx::after {
  content: " ";
  position: absolute;
  top: 100%;
  right: 50%;
  height: 0;
  width: 0;
  border-bottom: 1px solid currentColor;
  transition:
    right var(--fx-duration) ease-out,
    width var(--fx-duration) ease-out;
}
.x-underline-fx:hover::after,
.x-underline-fx:focus::after,
.x-underline-fx:active::after {
  right: 0;
  width: 100%;
}
</style>
